var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17088_91560)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#96C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6829 52.4983C35.6829 52.4983 32.2389 54.4525 29.0482 60.291C25.8575 66.1296 21.5752 73.283 18.1915 77.4869C14.8078 81.6909 12.7631 83.9588 14.669 86.5704C16.575 89.1821 30.0012 99.6348 30.0012 99.6348C30.0012 99.6348 30.345 101.903 30.912 102.813C31.4789 103.724 32.1605 104.743 32.1605 104.743C32.1605 104.743 30.5682 104.858 31.4789 105.763C32.438 106.646 33.5554 107.34 34.7722 107.807C35.1099 107.807 38.2946 99.6347 38.0654 99.1763C37.8362 98.7179 32.0338 94.4054 30.7974 91.6791C29.5609 88.9529 26.8226 83.5064 26.8226 83.5064L32.251 76.9139C32.251 76.9139 32.251 65.3334 33.7287 60.1041C35.2064 54.8747 36.3645 52.2691 35.6829 52.4983Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1342 82.3784C26.1342 82.3784 23.1788 78.9706 21.3633 78.2891",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2251 32.2578C64.2251 32.2578 62.1864 38.3738 62.0537 43.2171C61.9211 48.0604 68.043 46.5284 72.1204 49.2004C76.1977 51.8724 77.217 54.2971 77.3437 59.7737C77.4703 65.2503 67.4097 84.2316 67.0237 86.7829C66.6377 89.3342 68.1697 99.1355 68.2964 102.193C68.423 105.251 68.8091 112.26 69.3157 114.039C69.8224 115.819 71.3544 128.437 70.9744 140.156C70.5944 151.875 69.7017 153.552 70.4617 156.568C71.2217 159.584 73.779 166.248 71.8671 177.714C69.9551 189.18 67.645 199.627 67.645 201.153C67.645 202.679 68.1516 207.396 68.1516 207.396H59.5084C59.5084 207.396 58.8691 204.85 58.8691 199.627C58.8691 194.404 59.1284 189.687 58.7424 184.976C58.3564 180.266 56.1971 174.53 55.5578 168.287C55.1984 164.172 55.2854 160.031 55.8171 155.934L51.7398 137.587C51.7398 137.587 48.9351 156.568 48.8085 157.714C48.6818 158.86 48.3018 161.791 49.7012 167.141C51.1005 172.491 50.0811 179.114 49.1885 181.792C48.2958 184.47 45.3645 198.752 45.3645 198.752L44.8518 208.18C44.8518 208.18 41.6671 210.852 40.1412 210.592C38.6152 210.333 36.0638 208.427 35.9191 207.661C35.7743 206.895 35.2797 175.308 35.0264 171.87C34.7731 168.432 34.6464 160.657 34.6464 160.657C33.4178 155.331 32.6111 149.916 32.2338 144.462C31.9202 139.281 31.6307 131.561 33.6452 113.907C34.8033 103.828 33.7719 90.4682 33.0059 85.2449C32.2399 80.0216 29.8212 75.9442 30.8405 65.8836C31.8599 55.823 36.1905 50.9797 40.0145 49.4477C43.8385 47.9157 47.9098 48.0484 49.1824 45.7564C50.4551 43.4644 50.1897 39.0131 50.1897 39.0131L64.2251 32.2578Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.375 41.4197C51.4366 41.1483 62.233 40.9915 62.233 40.9915L64.2355 32.2578L50.375 41.4197Z",
    fill: "#222831",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8909 13.3658C48.8909 13.3658 45.3082 27.3952 44.5663 29.5002C43.8244 31.6052 44.3552 32.5582 45.7304 36.1349C47.1056 39.7116 47.7328 40.9601 50.3686 41.4065C53.0044 41.8528 57.2205 40.2484 59.6451 38.6681C62.0698 37.0879 64.2894 34.0239 65.2364 32.3411C66.1833 30.6583 68.8191 20.3142 68.8191 20.3142C68.9931 19.001 68.7995 17.6652 68.2596 16.4556C67.7197 15.2459 66.8548 14.2097 65.7611 13.4623C61.9673 10.9291 58.4871 9.77105 55.8513 10.2958C53.2155 10.8205 48.8909 13.3658 48.8909 13.3658Z",
    fill: "white",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0632 19.9062C51.921 21.8397 51.3436 23.716 50.3743 25.395C48.7941 28.0307 48.2452 28.4469 48.8785 29.3999C49.5118 30.3529 52.1175 31.8547 54.2285 29.2189",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1634 31.1875C56.1634 31.1875 54.2694 34.5652 49.4141 33.8233",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9531 19.9049C56.7857 19.7891 57.6336 19.9419 58.3734 20.341C59.1131 20.7402 59.7063 21.365 60.0666 22.1245",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7377 18.7445C51.7377 18.7445 50.4711 16.5309 48.6797 17.9",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3752 24.7635C56.1882 25.3666 56.3149 25.9215 56.6647 26.0361C57.0146 26.1507 57.4549 25.7647 57.6419 25.1736C57.8288 24.5825 57.7082 24.0095 57.3523 23.8949C56.9965 23.7803 56.5682 24.1724 56.3752 24.7635Z",
    fill: "#222831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6513 22.4918C49.4583 23.095 49.591 23.6559 49.9408 23.7705C50.2907 23.8851 50.731 23.493 50.918 22.9019C51.1049 22.3109 50.9783 21.7439 50.6284 21.6293C50.2786 21.5147 49.8383 21.9067 49.6513 22.4918Z",
    fill: "#222831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3373 30.1347C67.3373 30.1347 72.9225 19.8811 71.9755 17.0583C71.0286 14.2356 57.9522 4.72384 50.9918 5.99046C44.0314 7.25708 49.6166 8.83735 49.6166 8.83735C49.6166 8.83735 43.8203 11.6842 43.8203 13.7892C43.8203 15.8942 58.0547 13.1861 58.0547 13.1861C58.0547 13.1861 55.2079 15.5022 56.7881 16.033C58.3684 16.5637 61.746 17.2936 62.0657 17.4021C62.3854 17.5107 66.1732 20.5627 64.804 20.5627C63.4349 20.5627 61.8546 19.9595 62.5905 21.3045C63.0799 22.1938 63.6449 23.0393 64.2793 23.8317C64.2793 23.8317 63.4349 29.423 63.5374 29.9477C63.6399 30.4725 65.5399 28.5786 65.5399 28.5786L67.3373 30.1347Z",
    fill: "#222831",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6858 31.3323C63.6858 31.3323 66.4724 27.3756 68.1129 28.3165C69.7535 29.2575 67.6063 34.4325 66.4724 35.1503C65.3384 35.868 62.1719 34.5471 62.1719 34.5471",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6858 31.3323C63.6858 31.3323 66.4724 27.3756 68.1129 28.3165C69.7535 29.2575 67.6063 34.4325 66.4724 35.1503C65.3384 35.868 62.1719 34.5471 62.1719 34.5471",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 70.4757C33.2764 63.3465 36.2077 61.1811 38.7591 57.7371C40.267 55.6985 42.1367 51.5066 43.4094 48.4305C44.483 48.1711 45.5023 47.9419 46.395 47.6524C45.5566 48.9914 43.8859 52.2364 42.963 57.9965C41.6844 65.8918 45.3757 65.8918 50.605 63.9798C55.8344 62.0678 60.159 50.7104 61.5583 48.1832C62.1614 47.1096 62.6078 46.3074 62.9335 45.7344C63.7976 46.4588 64.8381 46.9416 65.9492 47.1337C62.0575 50.9634 59.2679 55.7696 57.873 61.0484C55.575 70.3491 61.691 77.7377 66.1483 78.3771C67.7367 78.539 69.3412 78.3475 70.8468 77.8161C68.8806 82.1468 67.1917 85.7657 67.041 86.785C66.8057 88.3653 67.3063 92.7623 67.7466 96.5923H34.0545C33.8132 91.8274 33.3789 87.6656 33.0231 85.253C32.4199 81.236 30.8698 77.9006 30.6406 71.9836C30.8135 71.5051 30.9703 71.0025 31.1111 70.4757Z",
    fill: "#FF4A01",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9741 63.4717C30.7297 63.4717 36.2061 57.9953 36.2061 51.2398C36.2061 44.4842 30.7297 39.0078 23.9741 39.0078C17.2186 39.0078 11.7422 44.4842 11.7422 51.2398C11.7422 57.9953 17.2186 63.4717 23.9741 63.4717Z",
    fill: "#1F76F9",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2476 63.4717C32.0031 63.4717 37.4795 57.9953 37.4795 51.2398C37.4795 44.4842 32.0031 39.0078 25.2476 39.0078C18.4921 39.0078 13.0156 44.4842 13.0156 51.2398C13.0156 57.9953 18.4921 63.4717 25.2476 63.4717Z",
    fill: "#222831",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2399 54.2375C26.8954 54.2375 28.2375 52.8954 28.2375 51.2399C28.2375 49.5843 26.8954 48.2422 25.2399 48.2422C23.5843 48.2422 22.2422 49.5843 22.2422 51.2399C22.2422 52.8954 23.5843 54.2375 25.2399 54.2375Z",
    fill: "#1F76F9",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.129 49.2084C72.129 49.2084 77.479 51.5003 77.9857 56.983C78.4923 62.4657 77.099 70.7349 72.129 75.1982C67.1591 79.6616 58.7511 93.1602 56.447 92.9008C54.143 92.6414 34.3596 75.9401 30.626 72.0015C26.8925 68.0629 21.8019 63.6056 20.1432 61.0543C18.7838 58.7288 17.835 56.1865 17.3386 53.539C17.2119 52.5197 21.6753 48.3157 23.0746 48.4484C24.4739 48.5811 26.5125 52.013 26.5125 52.013C26.5125 52.013 29.1905 52.9057 29.4439 53.8225C29.6972 54.7393 28.9312 55.8551 28.9312 56.7478C28.9312 57.6404 29.4439 59.4258 29.0578 60.3184C28.6718 61.2111 28.2979 62.3571 28.2979 62.3571C28.2979 62.3571 31.6092 65.0291 34.1545 66.1751C36.6998 67.3211 52.6291 72.9304 52.6291 72.9304C52.6291 72.9304 54.6678 67.8337 55.8137 66.1751C56.9597 64.5164 59.6317 62.8637 59.6317 62.8637C59.6317 62.8637 60.0177 59.5524 61.1637 57.8938",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.129 49.2084C72.129 49.2084 77.479 51.5003 77.9857 56.983C78.4923 62.4657 77.099 70.7349 72.129 75.1982C67.1591 79.6616 58.7511 93.1602 56.447 92.9008C54.143 92.6414 34.3596 75.9401 30.626 72.0015C26.8925 68.0629 21.8019 63.6056 20.1432 61.0543C18.7838 58.7288 17.835 56.1865 17.3386 53.539C17.2119 52.5197 21.6753 48.3157 23.0746 48.4484C24.4739 48.5811 26.5125 52.013 26.5125 52.013C26.5125 52.013 29.1905 52.9057 29.4439 53.8225C29.6972 54.7393 28.9312 55.8551 28.9312 56.7478C28.9312 57.6404 29.4439 59.4258 29.0578 60.3184C28.6718 61.2111 28.2979 62.3571 28.2979 62.3571C28.2979 62.3571 31.6092 65.0291 34.1545 66.1751C36.6998 67.3211 52.6291 72.9304 52.6291 72.9304C52.6291 72.9304 54.6678 67.8337 55.8137 66.1751C56.9597 64.5164 59.6317 62.8637 59.6317 62.8637C59.6317 62.8637 60.0177 59.5524 61.1637 57.8938",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6406 72.8984C52.6406 72.8984 53.1473 75.4437 54.2933 76.7164",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8587 63.5C31.2053 64.5148 32.6453 65.3994 34.1592 66.1418C34.7141 66.3891 35.8963 66.8475 37.4102 67.4145L33.2304 74.4834C32.0904 73.44 31.1796 72.5775 30.6308 71.9924C29.5451 70.8464 28.3448 69.6522 27.1445 68.4821L29.8587 63.5Z",
    fill: "#FF4A01",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9351 63.4717C35.6906 63.4717 41.167 57.9953 41.167 51.2398C41.167 44.4842 35.6906 39.0078 28.9351 39.0078C22.1796 39.0078 16.7031 44.4842 16.7031 51.2398C16.7031 57.9953 22.1796 63.4717 28.9351 63.4717Z",
    fill: "#1F76F9",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2163 63.4717C36.9718 63.4717 42.4483 57.9953 42.4483 51.2398C42.4483 44.4842 36.9718 39.0078 30.2163 39.0078C23.4608 39.0078 17.9844 44.4842 17.9844 51.2398C17.9844 57.9953 23.4608 63.4717 30.2163 63.4717Z",
    fill: "#1F76F9",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2164 54.2375C31.872 54.2375 33.2141 52.8954 33.2141 51.2399C33.2141 49.5843 31.872 48.2422 30.2164 48.2422C28.5609 48.2422 27.2188 49.5843 27.2188 51.2399C27.2188 52.8954 28.5609 54.2375 30.2164 54.2375Z",
    fill: "#1F76F9",
    stroke: "#222831",
    strokeWidth: 0.277451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17088_91560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerAccount);
export default __webpack_public_path__ + "static/media/customer-account.e4ba7d21d1f1d078651789f60e3bddc8.svg";
export { ForwardRef as ReactComponent };